import { PAYORDER_API } from '../baseURL'
import axios from '../config'

export default {
  /////////////////////////订单
  //获取订单列表
  getOrderList(fk_userGuid) {
    return axios.get(`${PAYORDER_API}/payOrder/list?fk_userGuid=${fk_userGuid}`);
  },
  //下订单
  storeBookPayOrder(data) {
    return axios.post(`${PAYORDER_API}/payOrder/storeBookPayOrder`, data);
  },
  //查订单
  findPayOrder(data) {
    let { pk_payorderGuid = '', fk_publishing_id = '', system_id = '', fk_userGuid = '' } = data;
    return axios.get(`${PAYORDER_API}/payOrder/payOrder?pk_payorderGuid=${pk_payorderGuid}&fk_publishing_id=${fk_publishing_id}&system_id=${system_id}&fk_userGuid=${fk_userGuid}`);
  },

  //////////////////////////优惠券
  //获取优惠券列表
  getCouponList(data) {
    let { fk_userGuid = '', status = '' } = data;
    return axios.get(`${PAYORDER_API}/coupon/list?fk_userGuid=${fk_userGuid}&status=${status}`);
  },
  
  //获取优惠券
  checkCode({ activation_code, fk_goodsGuid }) {
    return axios.get(`${PAYORDER_API}/coupon/checkCode?activation_code=${activation_code}&fk_goodsGuid=${fk_goodsGuid}`, {
      validateStatus: status => status === 200 || status === 422
    });
  },
  //修改优惠券信息
  updateCoupon(data) {
    return axios.put(`${PAYORDER_API}/coupon/coupon`, data);
  },
  //批量生成
  batchCreate(data) {
    return axios.post(`${PAYORDER_API}/coupon/batchCreate`, data);
  },
  //验证VIP激活码
  verifyCode(data) {
    return axios.post(`${PAYORDER_API}/coupon/verifyCode`, data);
  },

  ///////////////////////////支付
  //微信提交订单
  wechatSubmitOrder(data) {
    return axios.post(`${PAYORDER_API}/wechatpay/submitorder`, data);
  },
  // 主动确认微信交易，用于补偿微信回调未成功写入订单的情况
  confirmWechatOrder(data) {
    return axios.post(`${PAYORDER_API}/wechatpay/confirm-order`, data);
  },
  // 获取微信公众号网页授权地址
  getWechatOauthUrl({ redirect_url, fk_publishing_agency_id }) {
    return axios.get(`${PAYORDER_API}/wechatpay/oauth-url?redirect_url=${encodeURIComponent(redirect_url)}&fk_publishing_agency_id=${encodeURIComponent(fk_publishing_agency_id || '')}`);
  },
  // 用网页授权code换取当前支付公众号的openid
  getWechatOpenid({ code, state, fk_publishing_agency_id }) {
    return axios.get(`${PAYORDER_API}/wechatpay/openid?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state || '')}&fk_publishing_agency_id=${encodeURIComponent(fk_publishing_agency_id || '')}`);
  },
  //支付宝提交订单
  aliSubmitOrder(data) {
    return axios.post(`${PAYORDER_API}/alipay/submitorder`, data);
  },
}
